import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import GlobalErrorBoundary from 'Common/Components/GlobalErrorBoundary';
import Loading from 'Common/Components/Loading';
import HistoryObserver from 'Common/Components/HistoryObserver';
import ErrorBoundary from 'Common/pages/error';
import withWaitingComponent from 'Common/HOC/withWaitingComponent';

import withPusher from 'Common/HOC/withPusher';

import Login from 'Account/screens/Login';
import Pin from 'Account/screens/Pin';
import InstantLogin from 'Account/components/InstantLogin';
import ForgotPassword from 'Account/screens/ForgotPassword';
import ResetPassword from 'Account/screens/ResetPassword';
import Welcome from 'Home/components/Welcome';
import { PublicRoute, PrivateRoute, PinRoute } from './AppRouters';

const LegalRouter = React.lazy(
  () => import(/* webpackChunkName: "legalModule" */ 'Legal/Router')
);
const InventoryRouter = React.lazy(
  () => import(/* webpackChunkName: "inventoryModule" */ 'Inventory/Router')
);
const ContactsRouter = React.lazy(
  () => import(/* webpackChunkName: "contactsModule" */ 'Contacts/Router')
);
const ReportsRouter = React.lazy(
  () => import(/* webpackChunkName: "reportsModule" */ 'Reports/router')
);
const ShorePayRouter = React.lazy(
  () => import(/* webpackChunkName: "shorePayModule" */ 'ShorePay/Router')
);
const AppsRouter = React.lazy(
  () => import(/* webpackChunkName: "appsModule" */ 'AppsManagement/Router')
);
const DatevSection = React.lazy(
  () => import(/* webpackChunkName: "datevModule" */ 'Datev/router')
);
const KSVRouter = React.lazy(
  () => import(/* webpackChunkName: "ksvModule" */ 'KSV/Router')
);
const RKSVRouter = React.lazy(
  () => import(/* webpackChunkName: "rksvModule" */ 'RKSV/Router')
);
const SettingsRouter = React.lazy(
  () => import(/* webpackChunkName: "settingsModule" */ 'Settings/Router')
);

const Router = () => (
  <GlobalErrorBoundary>
    <BrowserRouter>
      <Suspense fallback={<Loading verticallyCentered noText />}>
        <Routes>
          <Route path="*" element={<ErrorBoundary />} />
          <Route path="/instant-login" element={<InstantLogin />} />
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
          <Route element={<PinRoute />}>
            <Route path="/pin" element={<Pin />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route index element={<Welcome />} />
            <Route path="/inventory/*" element={withPusher(InventoryRouter)} />
            <Route
              path="/imprint"
              element={withWaitingComponent(LegalRouter)}
            />
            <Route
              path="/api-apps"
              element={withWaitingComponent(AppsRouter)}
            />
            <Route
              path="/integrations/rksv/*"
              element={withWaitingComponent(RKSVRouter)}
            />
            <Route
              path="/integrations/kassensichv"
              element={withPusher(KSVRouter)}
            />
            <Route path="/settings/*" element={withPusher(SettingsRouter)} />
            <Route path="/contacts/*" element={withPusher(ContactsRouter)} />
            <Route path="/shorepay/*" element={withPusher(ShorePayRouter)} />
            <Route path="/reports/*" element={withPusher(ReportsRouter)} />
            <Route
              path="/integrations/datev/*"
              element={withWaitingComponent(DatevSection)}
            />
          </Route>
          <Route
            path="/billing/overdue-payment-return"
            element={<Navigate to="/" />}
          />
        </Routes>
      </Suspense>
      <HistoryObserver />
    </BrowserRouter>
  </GlobalErrorBoundary>
);

export default Router;
